/**
 * List of transaction statuses for AIB
 * Matches also with the values received by the landing_page received object.status (/aib/landing)
 */
export enum AibTransactionResultEnum {
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED',
  FAILED = 'FAILED',
  WAITING = 'WAITING',
  FRAUD = 'FRAUD',
}